import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  name: {
    id: 'make.name',
    defaultMessage: 'Name',
    description: 'Make name column header and form label',
  },
  systemDefined: {
    id: 'make.systemDefined',
    defaultMessage: 'System Defined',
    description: 'Indicates if the make is system defined',
  },
  inUse: {
    id: 'make.inUse',
    defaultMessage: 'In Use',
    description: 'Indicates if the make is currently in use',
  },
  yes: {
    id: 'common.yes',
    defaultMessage: 'Yes',
    description: 'Yes option for boolean fields',
  },
  no: {
    id: 'common.no',
    defaultMessage: 'No',
    description: 'No option for boolean fields',
  },
  editBtn: {
    id: 'common.edit',
    defaultMessage: 'Edit',
    description: 'Edit action button label',
  },
  deleteBtn: {
    id: 'common.delete',
    defaultMessage: 'Delete',
    description: 'Delete action button label',
  },
  add: {
    id: 'make.add',
    defaultMessage: 'Add Make',
    description: 'Add make button label',
  },
  deleteMakeTitle: {
    id: 'make.deleteMakeTitle',
    defaultMessage: 'Delete Make',
    description: 'Title for delete confirmation dialog',
  },
  deleteDescription: {
    id: 'make.deleteDescription',
    defaultMessage: 'Are you sure you want to delete this make?',
    description: 'Description for delete confirmation dialog',
  },
  title: {
    id: 'make.title',
    defaultMessage: 'Makes',
    description: 'Page title for the makes table',
  },
  createEditMake: {
    id: 'make.createEditMake',
    defaultMessage: 'Create/Edit Make',
    description: 'Header label for make form modal',
  },
  makeCreated: {
    id: 'make.makeCreated',
    defaultMessage: 'Make created successfully',
    description: 'Success message when make is created',
  },
  makeUpdated: {
    id: 'make.makeUpdated',
    defaultMessage: 'Make updated successfully',
    description: 'Success message when make is updated',
  },
  makeNotAdded: {
    id: 'make.makeNotAdded',
    defaultMessage: 'Failed to create make',
    description: 'Error message when make creation fails',
  },
  makeNotUpdated: {
    id: 'make.makeNotUpdated',
    defaultMessage: 'Failed to update make',
    description: 'Error message when make update fails',
  },
  nameRequired: {
    id: 'make.nameRequired',
    defaultMessage: 'Make name is required',
    description: 'Validation error message when make name is empty',
  },
  makeInUseError: {
    id: 'make.inUseError',
    defaultMessage: 'Make is in use and cannot be deleted',
    description: 'Error message when trying to delete a make that is in use',
  },
  makeDeleted: {
    id: 'make.deleted',
    defaultMessage: 'Make deleted successfully',
    description: 'Success message when make is deleted',
  },
  makeDeleteError: {
    id: 'make.deleteError',
    defaultMessage: 'Failed to delete make',
    description: 'Error message when make deletion fails',
  },
  viewMake: {
    id: 'make.viewMake',
    defaultMessage: 'View Make',
    description: 'Header label for view make modal',
  },
  viewBtn: {
    id: 'common.view',
    defaultMessage: 'View',
    description: 'View action button label',
  },
  cancel: {
    id: 'common.cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button label',
  },
  brandName: {
    id: 'brand.name',
    defaultMessage: 'Brand Name',
    description: 'Brand name column header and form label',
  },
  brandSystemDefined: {
    id: 'brand.systemDefined',
    defaultMessage: 'System Defined',
    description: 'Indicates if the brand is system defined',
  },
  brandInUse: {
    id: 'brand.inUse',
    defaultMessage: 'In Use',
    description: 'Indicates if the brand is currently in use',
  },
  viewBrandModal: {
    id: 'brand.viewBrand',
    defaultMessage: 'View Brand',
    description: 'Header label for view brand modal',
  },
  addBrand: {
    id: 'brand.add',
    defaultMessage: 'Add Brand',
    description: 'Add brand button label',
  },
  deleteBrandTitle: {
    id: 'brand.deleteBrandTitle',
    defaultMessage: 'Delete Brand',
    description: 'Title for delete confirmation dialog',
  },
  deleteBrandDescription: {
    id: 'brand.deleteDescription',
    defaultMessage: 'Are you sure you want to delete this brand?',
    description: 'Description for delete confirmation dialog',
  },
  brandTitle: {
    id: 'brand.title',
    defaultMessage: 'Brands',
    description: 'Page title for the brands table',
  },
  createEditBrand: {
    id: 'brand.createEditBrand',
    defaultMessage: 'Create/Edit Brand',
    description: 'Header label for brand form modal',
  },
  brandCreated: {
    id: 'brand.brandCreated',
    defaultMessage: 'Brand created successfully',
    description: 'Success message when brand is created',
  },
  brandUpdated: {
    id: 'brand.brandUpdated',
    defaultMessage: 'Brand updated successfully',
    description: 'Success message when brand is updated',
  },
  brandNotAdded: {
    id: 'brand.brandNotAdded',
    defaultMessage: 'Failed to create brand',
    description: 'Error message when brand creation fails',
  },
  brandNotUpdated: {
    id: 'brand.brandNotUpdated',
    defaultMessage: 'Failed to update brand',
    description: 'Error message when brand update fails',
  },
  brandNameRequired: {
    id: 'brand.nameRequired',
    defaultMessage: 'Brand name is required',
    description: 'Validation error message when brand name is empty',
  },
  brandInUseError: {
    id: 'brand.inUseError',
    defaultMessage: 'Brand is in use and cannot be deleted',
    description: 'Error message when trying to delete a brand that is in use',
  },
  brandDeleted: {
    id: 'brand.deleted',
    defaultMessage: 'Brand deleted successfully',
    description: 'Success message when brand is deleted',
  },
  brandDeleteError: {
    id: 'brand.deleteError',
    defaultMessage: 'Failed to delete brand',
    description: 'Error message when brand deletion fails',
  },
  viewBrandBtn: {
    id: 'brand.viewBrand',
    defaultMessage: 'View Brand',
    description: 'Header label for view brand modal',
  },
})
